// extracted by mini-css-extract-plugin
export default {"top":"HeaderHoliday_top__NZlsj","box":"HeaderHoliday_box__y0Dea","addButton":"HeaderHoliday_addButton__YBDa8"};